import firebase from 'datastore/database';

export async function fetchWaitlistEntry(businessUid, entryUid) {
  const doc = await firebase.firestore()
    .collection(`waitlist/business/${businessUid}`)
    .doc(entryUid)
    .get();
  return { uid: doc.id, ...doc.data() };
}